import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DangerConfirmationModal from './presetModals/DangerConfirmationModal/DangerConfirmationModal';
import styles from './Modal.scss';

const Modal = ({
    open,
    onClose,
    Content,
    contentData,
    type,
    onApprove,
    staticTexts,
    data
}) => {
    const modalsMapping = {
        'dangerConfirmation': DangerConfirmationModal
    }
    const PresetModal = modalsMapping[type];

    return (
        <Dialog
            open={open}
            maxWidth={false}
            className={styles.container}
            onBackdropClick={onClose}
            onEscapeKeyDown={onClose}
        >
            <DialogContent>
                {
                    PresetModal
                    ? 
                    <PresetModal onClose={onClose} onApprove={onApprove} staticTexts={staticTexts} data={data}/>
                    :
                    <Content onClose={onClose} { ...contentData } />
                }   
            </DialogContent>
        </Dialog>
    )
};

Modal.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    Content: PropTypes.elementType,
    contentData: PropTypes.object,
    type: PropTypes.string,
    onApprove: PropTypes.func,
    staticTexts: PropTypes.shape({
        title: PropTypes.string,
        subTitle: PropTypes.string,
        cancelButton: PropTypes.string,
        approveButton: PropTypes.string
    }),
    data: PropTypes.object
};

Modal.defaultProps = {
    open: false,
    contentData: {},
    Content: '',
    onApprove: () => {},
    staticTexts: {},
    data: {},
    type: ''
};

export default Modal;
